<template>
  <div
    class="main-menu menu-fixed menu-accordion"
    :class="[
      { 'expanded': !isVerticalMenuCollapsed || (isVerticalMenuCollapsed && isMouseHovered) },
      skin === 'semi-dark' ? 'menu-dark' : 'menu-light'
    ]"
    @mouseenter="updateMouseHovered(true)"
    @mouseleave="updateMouseHovered(false)"
  >
    <!-- main menu header-->
    <div class="navbar-header expanded">
     
      <div :class="{'switch-container': $user.main_account}" @click="$user.main_account?switcherOpened=!switcherOpened:null">
        <img v-if="$user.main_account" src="@/assets/images/switch.svg" class="switch" alt="logo" />
        <slot
          name="header"
          :toggleVerticalMenuActive="toggleVerticalMenuActive"
          :toggleCollapsed="toggleCollapsed"
          :collapseTogglerIcon="collapseTogglerIcon"
        >
          <div class="d-sm-flex d-none user-nav mt-1 mb-1">

            
        
            <b-avatar

            v-if="$user.brand_logo"
              size="50"
              variant="light-primary"
              badge

              :src="$user.brand_logo ? $user.brand_logo : require('@/assets/images/avatars/13-small.png')"
              class="badge-minimal"
              badge-variant="success"
            />
            <b-avatar
              v-else
              size="50"
              variant="light-primary"
              badge

            :text="$user.name[0] + $user.surname[0]"
              class="badge-minimal"
              badge-variant="success"
            />
              <p class="user-name mb-0 ml-1">
                <span class="name">{{$user.name}} {{$user.surname}}</span><br />
                {{$user.main_account ? 'Main Account' : $isFactory ? 'Factory Account' : $user.main_user?'Shop Account' : 'Admin'}}
              </p>
          
            </div>
          
          <ul class="nav navbar-nav flex-row">

          

            <!-- Toggler Button
            <li class="nav-item nav-toggle">
              <b-link class="nav-link modern-nav-toggle">
                <feather-icon
                  icon="XIcon"
                  size="20"
                  class="d-block d-xl-none"
                  @click="toggleVerticalMenuActive"
                />
                <feather-icon
                  :icon="collapseTogglerIconFeather"
                  size="20"
                  class="d-none d-xl-block collapse-toggle-icon"
                  @click="toggleCollapsed"
                />
              </b-link>
            </li>
            -->
          </ul>
        </slot>
        
      </div>
    </div>
    <!-- / main menu header-->
    <div v-if="switcherOpened" class="switcher-content">
      <div class="d-sm-flex d-none user-nav user-nav-main mt-1 mb-1" @click="switchAccount(null)">
        <img src="@/assets/images/valid.svg" v-if="$active_account==null" class="check-user" />
        <b-avatar

        v-if="$user.brand_logo"
          size="50"
          variant="light-primary"
          

          :src="$user.brand_logo ? $user.brand_logo : require('@/assets/images/avatars/13-small.png')"
          class="badge-minimal"
          badge-variant="success"
        />
        <b-avatar
          v-else
          size="50"
          variant="light-primary"
          

        :text="$user.name[0] + $user.surname[0]"
          class="badge-minimal"
          badge-variant="success"
        />
          <p class="user-name mb-0 ml-1">
            <span class="name">{{$user.name}} {{$user.surname}}</span><br />
            {{$user.main_account ? 'Main Account' : $isFactory ? 'Factory Account' : $user.main_user?'Shop Account' : 'Admin'}}
          </p>
      
        </div>
      <div v-for="user in $user.sub_accounts" @click="switchAccount(user)" class="d-sm-flex d-none user-nav user-nav-main mt-1 mb-1">
        <template v-if="$active_account">
          <img src="@/assets/images/valid.svg" v-if="$active_account.id==user.id" class="check-user" />
        </template>
        <b-avatar

        v-if="user.brand_logo"
          size="50"
          variant="light-primary"
          

          :src="user.brand_logo ? user.brand_logo : require('@/assets/images/avatars/13-small.png')"
          class="badge-minimal"
          badge-variant="success"
        />
        <b-avatar
          v-else
          size="50"
          variant="light-primary"
          

        :text="user.name[0] + user.surname[0]"
          class="badge-minimal"
          badge-variant="success"
        />
          <p class="user-name mb-0 ml-1">
            <span class="name">{{user.name}} {{user.surname}}</span><br />
            {{user.main_account ? 'Main Account' : $isFactory ? 'Factory Account' : user.main_user?'Shop Account' : 'Admin'}}
          </p>
      
        </div>

      <div class="switcher-content-item" @click="openAddAccountPopup">
        <img src="@/assets/images/add.svg" width="16" alt="logo" />
        <span>Add new account</span>
      </div>
    </div>
    <!-- Shadow -->
    <div
      :class="{'d-block': shallShadowBottom}"
      class="shadow-bottom"
    />

    <!-- main menu content-->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="main-menu-content scroll-area"
      tagname="ul"
      @ps-scroll-y="evt => { shallShadowBottom = evt.srcElement.scrollTop > 0 }"
    >
      <vertical-nav-menu-items
        :items="navMenuItems"
        class="navigation navigation-main"
      />
    </vue-perfect-scrollbar>
    <!-- /main menu content-->
     <div class="logout-button" @click="logout()">
      <img src="@/assets/images/logout.svg" alt="logout" />
      <span>Logout</span>
     </div>
  </div>
</template>

<script>
import { getNavMenuItems } from '@/navigation/vertical'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { BLink, BImg,BAvatar } from 'bootstrap-vue'
import { provide, computed, ref, getCurrentInstance } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'
import { $themeConfig } from '@themeConfig'
import VerticalNavMenuItems from './components/vertical-nav-menu-items/VerticalNavMenuItems.vue'
import useVerticalNavMenu from './useVerticalNavMenu'
import {Auth} from "@simb2s/senseye-sdk"
import emitter from 'tiny-emitter/instance'

export default {
  components: {
    VuePerfectScrollbar,
    VerticalNavMenuItems,
    BLink,
    BImg,
    BAvatar
  },
  props: {
    isVerticalMenuActive: {
      type: Boolean,
      required: true,
    },
    toggleVerticalMenuActive: {
      type: Function,
      required: true,
    },
  },
  data()
  {
    return {
      switcherOpened: false,
    }
  },
  setup(props) {
    const {
      isMouseHovered,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      updateMouseHovered,
    } = useVerticalNavMenu(props)

    const { skin } = useAppConfig()

    // Shadow bottom is UI specific and can be removed by user => It's not in `useVerticalNavMenu`
    const shallShadowBottom = ref(false)

    provide('isMouseHovered', isMouseHovered)

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    }

    const collapseTogglerIconFeather = computed(() => (collapseTogglerIcon.value === 'unpinned' ? 'CircleIcon' : 'DiscIcon'))

    // App Name
    const { appName, appLogoImage } = $themeConfig.app

    const vm = getCurrentInstance().proxy
    const navMenuItems = computed(() => getNavMenuItems(vm.$user, vm.$active_account))

    return {
      navMenuItems,
      perfectScrollbarSettings,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      isMouseHovered,
      updateMouseHovered,
      collapseTogglerIconFeather,

      // Shadow Bottom
      shallShadowBottom,

      // Skin
      skin,

      // App Name
      appName,
      appLogoImage,
    }
  },
  methods: {
    switchAccount(user) {
      this.$active_account = user
      this.switcherOpened = false
    },
    openAddAccountPopup() {
      this.switcherOpened = false
      emitter.emit('show-add-account-popup')
    },
    async logout()
    {
      await Auth.logout()
      document.location.reload(); 
    },
  },
}
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/vertical-menu.scss";
.user-name
{
  color:#999;
}
.name 
{
  color:#000 !important;
}
.navigation-main
{
  margin-top:20px !important;
}
.logout-button img
{
  margin-right:10px;
} 
.check-user

{
  width:18px;
  position:absolute;
  top:50%;
  transform:translateY(-50%);
  right:0;
}
.logout-button
{
  position:absolute;
  bottom:10px;
  left:10px;
  color:#000;
  padding:10px;
  cursor:pointer;
}
.switch-container
{
  position:relative;
  cursor:pointer;
}
.user-nav-main
{
  cursor:pointer;
  position:relative;
}
.switch
{
  position:absolute;
  top:30%;
  right:0px;
  transform:translateY(-50%);
  width:10px;
 
}
.switcher-content
{
  position:absolute;
  top:86px;
  left:0;
  width:100%;
  
  z-index:2;
  backdrop-filter:blur(15px);
  background-color:rgba(255,255,255,0.7);
  padding:20px;
  border-radius:5px;

}
.switcher-content-item
{
  display:flex;
  align-items:center;
  gap:15px;
  justify-content:flex-start;
  cursor:pointer;

  padding-top:20px;
  border-top:1px solid #999;

}
</style>
